import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useGetIsBookingFull_Booking$key } from "./__generated__/useGetIsBookingFull_Booking.graphql";

export function useGetIsBookingFull({
  bookingFragmentRef,
}: {
  bookingFragmentRef: useGetIsBookingFull_Booking$key | null;
}): boolean {
  const booking = useFragment(
    useGetIsBookingFullFragmentString,
    bookingFragmentRef
  );

  const isRequestBooking = booking?.startSlot?.__typename === "QueueSlot";
  const capacity =
    booking?.startSlot?.__typename === "TimeSlot" ||
    booking?.startSlot?.__typename === "QueueSlot"
      ? booking?.startSlot?.capacity ?? 0
      : 0;

  const usedCapacity =
    booking?.startSlot?.__typename === "TimeSlot"
      ? booking?.startSlot?.usedCapacity ?? 0
      : 0;

  const roundsCount = booking?.rounds?.count ?? 0;

  const remainingCapacity = isRequestBooking
    ? (capacity ?? 0) - (roundsCount ?? 0)
    : (capacity ?? 0) - (usedCapacity ?? 0);

  const isBookingFull = remainingCapacity === 0;

  return isBookingFull;
}

export const useGetIsBookingFullFragmentString = graphql`
  fragment useGetIsBookingFull_Booking on Booking {
    startSlot {
      __typename
      ... on TimeSlot {
        capacity(bookingType: $bookingType)
        usedCapacity
      }
      ... on QueueSlot {
        capacity(bookingType: $bookingType)
      }
    }
    rounds {
      count
    }
  }
`;
